import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import WhatIfScenarioTableDto from '../dto/WhatIfScenarioTableDto';

class WhatIfScenarioTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'whatIfScenarioTableControl';
	}

	/**
	 * @param {number} whatIf
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<WhatIfScenarioTableDto>>}
	 */
	getList(whatIf, session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					whatIf,
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, WhatIfScenarioTableDto)))
				.catch(reject);
		});
	}
}

export default new WhatIfScenarioTableService();
